<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row mb-2">
      <div class="col-xs-12 col-sm-8 text-center mb-2">
        <div class="card h-100">
          <div class="card-body">
            <div class="row mt-5 mb-5 mx-auto" v-if="loading">
              <div class="col-12 p-5 m-4 text-center">
                <div
                  class="spinner-border text-secondary"
                  role="status"
                  v-if="loading"
                >
                  <span class="sr-only">Loading..</span>
                </div>
              </div>
            </div>
            <div v-if="!loading">
              <h5 class="card-title mb-2 mt-2">
                <b>{{ $t("log.top-bandwidth-group") }}</b>
              </h5>
              <p>Satuan Megabyte (MB)</p>
              <apexchart
                class="apex-charts"
                dir="ltr"
                height="700"
                :series="bandwidth_series"
                :options="categoryOptions.chartOptions"
              ></apexchart>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-sm-4 text-center mb-2">
        <div class="card h-100">
          <div class="card-body">
            <div class="row mt-5 mb-5 mx-auto" v-if="loading">
              <div class="col-12 p-5 m-4 text-center">
                <div
                  class="spinner-border text-secondary"
                  role="status"
                  v-if="loading"
                >
                  <span class="sr-only">Loading..</span>
                </div>
              </div>
            </div>
            <div v-if="!loading">
              <h4>
                <b>
                  Total Bandwidth :
                  <span class="text-success"
                    >{{ total_bandwidth.bandwidth_in_gb }} GB</span
                  >
                </b>
              </h4>
              <hr />
              <h6 class="py-2 text-left">
                {{ $t("log.top-bandwidth-group") }}
              </h6>
              <table class="table table-bordered">
                <thead>
                  <th width="10%">No</th>
                  <th class="text-left">{{ $t("user-management.name") }}</th>
                  <th width="30%" class="text-right">Total (MB)</th>
                </thead>
                <tbody>
                  <tr
                    v-for="(data, index) in tableData.slice(0, 10)"
                    :key="data.name"
                  >
                    <td>{{ index + 1 }}</td>
                    <td class="text-left">{{ data.name }} <br /></td>
                    <td class="text-right">{{ data.bandwidth_in_mb }} MB</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import StatistikService from "@/helpers/statistik.service";
import store from "@/state/store";
import moment from "moment";
import { tableData } from "../applications/dataAdvancedtable";

export default {
  page: {
    title: "Bandwidth",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    let categoryOptions = {
      chartOptions: {
        chart: {
          type: "pie",
        },
        labels: [],
        colors: [
          "#ea580c",
          "#059669",
          "#34d399",
          "#e11d48",
          "#2563eb",
          "#eab308",
          "#475569",
          "#94a3b8",
          "#84cc16",
          "#60a5fa",
          "#0891b2",
          "#e879f9",
        ],
        legend: {
          show: true,
          position: "bottom",
          labels: {
            colors: "#74788d",
          },
        },
      },
    };

    return {
      categoryOptions,
      bandwidth_series: [0.02, 4.5, 0.2],
      total_bandwidth: 0,
      tableData: [],
      title: this.$t("log.log-call-group-grafik"),
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: this.$t("log.log-call"),
          href: "/log-group-call",
        },
        {
          text: this.$t("log.log-call-group-grafik"),
          active: true,
        },
      ],
      loading: false,
      loading_message: false,
    };
  },

  computed: {
    sortedArray() {
      function compare(a, b) {
        if (a.bandwidth < b.bandwidth) return -1;
        if (a.bandwidth > b.bandwidth) return 1;
        return 0;
      }
      return this.tableData.sort(compare);
    },
  },
  mounted() {
    this.getBandwith();
    this.getTotalBandwith();
  },
  methods: {
    getBandwith() {
      this.loading = true;
      StatistikService.getTopBandwidth()
        .then((response) => {
          this.bandwidth_series = [];
          // this.tableData = response.data.data;
          // this.tableDatacall = response.data.data;
          console.log(response.data.data);
          response.data.data.forEach((val) => {
            const data = {
              name: val.name,
              bandwidth: val.bandwidth,
              bandwidth_in_mb: val.bandwidth_in_mb,
            };
            this.tableData.push(data);
            this.categoryOptions.chartOptions.labels.push(val.name);
            this.bandwidth_series.push(val.bandwidth_in_mb);
          });
          this.sortedArray();
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          // console.log(err);
        });
    },

    getTotalBandwith() {
      this.loading = true;
      StatistikService.getTotalBandwidth()
        .then((response) => {
          console.log("total bandwidth", response.data.data);
          this.total_bandwidth = response.data.data;
        })
        .catch((err) => {
          this.loading = false;
          // console.log(err);
        });
    },

    formatDate(value) {
      return moment(value).format("YYYY-MM-DD, HH:mm");
    },

    formatPrice(value) {
      return value.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1\.");
    },

    formatDateTimes(value) {
      var unixTime = value;
      var momentDate = moment.unix(unixTime),
        momentDay = momentDate.format("DD"),
        momentMonth = momentDate.format("MM"),
        momentYear = momentDate.format("YYYY"),
        momentHours = momentDate.format("HH"),
        momentMinutes = momentDate.format("mm"),
        momentSeconds = momentDate.format("ss");
      // let time = momentYear+'-'+momentMonth+'-'+momentDay+' '+momentHours+':'+momentMinutes+':'+momentSeconds;

      var t =
        '"' +
        momentYear +
        "-" +
        momentMonth +
        "-" +
        momentDay +
        " " +
        momentHours +
        ":" +
        momentMinutes +
        '"';
      var cdt = moment(t, "YYYY-MM-DD HH:mm");
      let a = this.formatDate(cdt);
      return a;
    },
  },
};
</script>
